import { useNavigate } from 'react-router';
import { Button, Stack, IconButton } from '@mui/material';
import { PageHeader } from '../../components/page-header';
import { SearchField } from '../../components/fields';
import { administratorsColumn, administratorsData } from './_mockdata';
import { TableView } from '../../components/table-view';
import { IconPen, IconTrash } from '../../components/icons';
import {
  ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE,
  ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE_CREATE,
  ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE_EDIT
} from '../../constants/route.paths';
import { url } from '../../core/utils/route.utils';
import { useDialog } from '../../core/hooks/useDialog';
import { ConfirmDialog } from '../../components/dialogs/ConfirmDialog';

export const SuperAdminAdministratorsContainer = () => {
  const navigate = useNavigate();
  const [openConfirm, closeConfirm] = useDialog(ConfirmDialog);

  const handleConfirmUserTermination = (uuid: string) => {
    openConfirm({
      title: 'Confirm user termination',
      message: 'Do you really want to terminate Dianne Russell?',
      onConfirm: () => {
        console.log(uuid);
        closeConfirm();
      }
    });
  };

  return (
    <>
      <PageHeader title="Administrators">
        <Button color="secondary">Export</Button>
      </PageHeader>
      <Stack direction="row" justifyContent="space-between">
        <Button
          onClick={() =>
            navigate(url(ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE_CREATE))
          }
        >
          Add new
        </Button>
        <SearchField
          sx={{ width: 400, mb: 3 }}
          size="small"
          placeholder="Search"
        />
      </Stack>
      <TableView
        showEmptyState
        showTablePerPage
        showPagination
        onRowClick={(record) =>
          navigate(
            url(ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE, {
              id: record.id
            })
          )
        }
        dataSource={administratorsData}
        columns={[
          ...administratorsColumn,
          {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: () => (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <IconButton
                  size="small"
                  onClick={(evt: any) => {
                    evt.stopPropagation();
                    navigate(
                      url(ROUTE_SUPER_ADMIN_ADMINISTRATOR_PROFILE_EDIT, {
                        id: '123'
                      })
                    );
                  }}
                >
                  <IconPen />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={(evt: any) => {
                    evt.stopPropagation();
                    handleConfirmUserTermination('123');
                  }}
                >
                  <IconTrash />
                </IconButton>
              </Stack>
            )
          }
        ]}
      />
    </>
  );
};
